import { render, staticRenderFns } from "./OtherServicesTable.vue?vue&type=template&id=594218f2&"
import script from "./OtherServicesTable.vue?vue&type=script&lang=ts&"
export * from "./OtherServicesTable.vue?vue&type=script&lang=ts&"
import style0 from "./OtherServicesTable.vue?vue&type=style&index=0&id=594218f2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports